import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  services: [],
  service: null,
  loading: false,
  error: null
};

export const serviceSlice = createSlice({
  name: 'service',
  initialState,
  reducers: {
    fetchServicesStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchServicesSuccess: (state, action) => {
      state.loading = false;
      state.services = action.payload;
      state.error = null;
    },
    fetchServicesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchServiceStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchServiceSuccess: (state, action) => {
      state.loading = false;
      state.service = action.payload;
      state.error = null;
    },
    fetchServiceFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    }
  }
});

export const {
  fetchServicesStart,
  fetchServicesSuccess,
  fetchServicesFailure,
  fetchServiceStart,
  fetchServiceSuccess,
  fetchServiceFailure
} = serviceSlice.actions;

export default serviceSlice.reducer; 